import { createContent } from './reducers/pages';

export const queries = {
  profile: {
    byId: (db, uid) => db.ref(`/profiles/${uid}`),
    loginCount: (db, uid) => db.ref(`/profiles/${uid}/loginCount`),
  },

  pages: {
    new: (db) => db.createId('pages'),
    byProjectId: (db, projectId) => db.ref(`/pages/${projectId}`),
    byId: (db, projectId, pageId) => db.ref(`/pages/${projectId}/${pageId}`)
  },

  versions: {
    new: (db) => db.createId('versions'),
    byId: (db, pageId, versionId) => db.ref(`/versions/${pageId}/${versionId}`)
  },

  content: {
    byVersionId: (db, versionId) => db.ref(`/content/${versionId}`)
  }
}

export const DEFAULT_DRAFT_TITLE = 'New Document';

export const mutations = {
  createVersion: (db, projectId, pageId, draft) => {
    const versionId = queries.versions.new(db);

    const page = { versionId };
    const version = { title: draft.title || DEFAULT_DRAFT_TITLE };
    const content = createContent(draft.content);

    db.update({
      [`/pages/${projectId}/${pageId}`]: page,
      [`/versions/${pageId}/${versionId}`]: version,
      [`/content/${versionId}`]: content
    });

    return { page, version: {...version, id: versionId }, content };
  },

  deletePage: (db, projectId, pageId) => {
    const pageRef = queries.pages.byId(db, projectId, pageId);

    return pageRef.once('value').then(snapshot => {
      const page = snapshot.val();

      db.update({
        [`/pages/${projectId}/${pageId}`]: null,
        [`/pages_deleted/${projectId}/${pageId}`]: page
      });
    });
  }
}


/** WEBPACK FOOTER **
 ** ./src/store/persistence.js
 **/